export const MACRO_FOLDER_NAMES = {
  'macro-ctv': 'Macro CTV',
  'macro-gif': 'Macro GIF',
  'macro-saca-tu-tarjeta': 'Sacá tu tarjeta'
} as const;
